import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { mockData } from '../data/mock';

const MemberSuccessStories = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-800 to-slate-900">
      {/* Header */}
      <header className="bg-slate-900/95 backdrop-blur-sm border-b border-amber-400/30 shadow-xl py-6">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 bg-gradient-to-r from-amber-400 to-amber-600 rounded-lg flex items-center justify-center shadow-lg">
                <span className="text-slate-900 font-bold text-lg">L</span>
              </div>
              <h1 className="text-2xl font-bold text-white">Legacy Property Association</h1>
            </div>
            <Button
              onClick={() => window.history.back()}
              variant="outline"
              className="border-amber-400/30 text-amber-100 hover:bg-amber-50/10"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 font-serif">
              Member Success Stories
            </h2>
            <p className="text-xl text-amber-200 max-w-3xl mx-auto">
              Real experiences from property owners who've joined our private member association and transformed their investment journey.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {mockData.testimonials.map((testimonial, index) => (
              <Card key={index} className="bg-white/10 backdrop-blur-sm border border-amber-400/30 hover:bg-white/20 transition-all duration-300">
                <CardContent className="p-6">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-gradient-to-r from-amber-400 to-amber-600 rounded-full flex items-center justify-center text-slate-900 font-bold text-lg mr-4">
                      {testimonial.name.charAt(0)}
                    </div>
                    <div>
                      <h3 className="font-semibold text-white font-serif">{testimonial.name}</h3>
                      <p className="text-amber-200 text-sm">{testimonial.title}</p>
                    </div>
                  </div>
                  
                  <div className="flex mb-4">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                    ))}
                  </div>
                  
                  <blockquote className="text-amber-100 italic leading-relaxed">
                    "{testimonial.quote}"
                  </blockquote>
                  
                  <div className="mt-4 pt-4 border-t border-amber-400/20">
                    <p className="text-amber-300 text-sm font-medium">
                      {testimonial.location} • {testimonial.properties} Properties
                    </p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
          
          <div className="text-center mt-16">
            <Button
              onClick={() => window.history.back()}
              className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-slate-900 font-semibold px-8 py-3"
            >
              Join Our Community Today
            </Button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 border-t border-amber-400/30 py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-amber-200">
            © 2024 Legacy Property Association. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default MemberSuccessStories;